import { useRouter, type AppNavConfig } from '@khaddi/ui';
import { useMemo } from 'react';

export type ShipperTab = 'home' | 'history' | 'earnings' | 'account';

const TAB_PATHS: Record<ShipperTab, string> = { home: '/', history: '/history', earnings: '/earnings', account: '/account' };

/** Main nav for `Screen`; the delivery screens pass `{ wideOnly: true }` so phones keep their full-screen map. */
export const useShipperNav = (active: ShipperTab, { wideOnly = false }: { wideOnly?: boolean } = {}): AppNavConfig => {
  const { navigate } = useRouter();
  return useMemo(() => {
    const go = (tab: ShipperTab) => () => navigate(TAB_PATHS[tab], { replace: true });
    return {
      items: [
        { key: 'home', label: 'Nhận đơn', icon: 'bike', onPress: go('home') },
        { key: 'history', label: 'Lịch sử', icon: 'receipt', onPress: go('history') },
        { key: 'earnings', label: 'Thu nhập', icon: 'wallet', onPress: go('earnings') },
        { key: 'account', label: 'Tài khoản', icon: 'user', onPress: go('account') },
      ],
      active,
      label: 'Điều hướng shipper',
      wideOnly,
    };
  }, [navigate, active, wideOnly]);
};
